import axios from "axios"
import Vue from "vue"
import { confirmLeadChanges } from "./leadConfirmation"
import { notifyLeadUpdate } from "./leadUpdateNotice"

export async function handleAppointmentLeadResult(response) {
  const key = response && response.headers && response.headers["x-roody-lead-confirmation"]
  if (!key) return notifyLeadUpdate(response)
  const url = `/api/studio-operation/appointment-leads/confirmation/${encodeURIComponent(key)}`
  const options = { headers: { Authorization: localStorage.getItem("token") } }
  try {
    for (let attempt = 0; attempt < 3; attempt++) {
      const { data: review } = await axios.get(url, options)
      if (!review.items || !review.items.length) return response
      const confirmed = await confirmLeadChanges(review)
      try {
        await axios.post(url, { confirmed, token: review.token }, options)
        return response
      } catch (error) {
        if (confirmed && error.response && error.response.status === 409 && attempt < 2) continue
        throw error
      }
    }
  } catch (_) {
    if (Vue.prototype.$toast) Vue.prototype.$toast.info("Der Termin ist gespeichert. Die Lead-Änderung konnte nicht vollständig abgeschlossen werden.")
  }
  // The calendar request has already succeeded. Never replay it or report it
  // as a failed save when only the separate lead decision could not complete.
  return response
}
